export default __webpack_public_path__ + "static/media/data-not-found.900e7173.webp";